var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "incomingcalls" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("MetricGraph", {
              attrs: {
                metrics: _vm.metrics,
                name: "Total Calls",
                date: _vm.date,
                period: _vm.period,
                lastUpdate: _vm.lastUpdate
              },
              on: { updateMetric: _vm.updateMetric }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          "calls" in _vm.report && _vm.report.calls.length > 0
            ? _c(
                "div",
                { staticClass: "numbers-graph", attrs: { id: "numbers" } },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-heading" }, [
                        _c("h5", { staticClass: "card-title" }, [
                          _vm._v("Numbers")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-body",
                          staticStyle: { padding: "0" }
                        },
                        [
                          _c("phone-numbers-bar", {
                            attrs: { numbers: _vm.report.from }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column" }, [
          "calls" in _vm.report && _vm.report.calls.length > 0
            ? _c(
                "div",
                { attrs: { id: "timeline" } },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-heading",
                          staticStyle: { "padding-left": "15px" }
                        },
                        [
                          _c("h5", { staticClass: "card-title" }, [
                            _vm._v("Timeline (UTC)")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-body",
                          staticStyle: { padding: "0" }
                        },
                        [
                          _c("CallsTimeline", {
                            attrs: {
                              period: _vm.period,
                              date: _vm.date,
                              calls: _vm.report.calls
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column" }, [
          "calls" in _vm.report && _vm.report.calls.length > 0
            ? _c(
                "div",
                { staticClass: "calls", attrs: { id: "calls" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [_c("CallLogs", { attrs: { report: _vm.report } })],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          "calls" in _vm.report && _vm.report.calls.length > 0
            ? _c(
                "div",
                { attrs: { id: "stats" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [_c("MetricCallLogs", { attrs: { report: _vm.report } })],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "nav",
      { staticClass: "navbar fixted-top navbar-light bg-light" },
      [
        _c("div", { staticClass: "navbar-brand" }, [_vm._v("Calls")]),
        _vm._v(" "),
        _c("ul", { staticClass: "nav nav-pages mr-auto" }, [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              { staticClass: "nav-link active", attrs: { type: "button" } },
              [_vm._v("summary")]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e91a05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e91a05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IncomingCalls.vue
// module id = null
// module chunks = 